import { render } from "./ModalSearch.vue?vue&type=template&id=161f50c4"
import script from "./ModalSearch.vue?vue&type=script&lang=js"
export * from "./ModalSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__